import { Zap, ShoppingBag } from "lucide-react";

export const SERVICES = [
  { key: "COURSE", title: "COURSE", subtitle: "Documents, plis, plats & petits objets", base: 10, icon: Zap },
  { key: "MARCHANDISE", title: "MARCHANDISE", subtitle: "Cartons, colis & commandes resto · tarif au poids", base: 15, icon: ShoppingBag },
];

export const IDF_SUGGESTIONS = [
  "Place du Châtelet, Paris",
  "Boulogne-Billancourt",
  "Saint-Denis, France",
  "Château de Versailles",
  "Montreuil, France",
  "Place de la République, Paris 11e",
];

export const STATUS_STYLES = {
  Nouveau: "bg-blue-500/15 text-blue-300 border-blue-500/40",
  "Accepté": "bg-purple-500/15 text-purple-300 border-purple-500/40",
  "En cours": "bg-amber-500/15 text-amber-300 border-amber-500/40",
  "Livré": "bg-emerald-500/15 text-emerald-300 border-emerald-500/40",
  "Annulé": "bg-rose-500/15 text-rose-300 border-rose-500/40",
};

export const AVAILABILITY = {
  disponible: { label: "Disponible", color: "text-emerald-400", dot: "bg-emerald-400", ring: "border-emerald-500/50 bg-emerald-500/10" },
  occupe: { label: "Occupé", color: "text-amber-400", dot: "bg-amber-400", ring: "border-amber-500/50 bg-amber-500/10" },
  hors_ligne: { label: "Hors ligne", color: "text-slate-400", dot: "bg-slate-500", ring: "border-slate-600/50 bg-slate-700/10" },
};

export const PAYMENT_LABEL = "Prix fixé — Paiement en espèces à la livraison";
export const PAYMENT_SUBTEXT =
  "Le règlement s'effectue directement en liquide auprès du livreur lors de la remise du colis/repas.";
